<template lang="pug">
#plansTable.d-flex.align-center.py-16.px-2.px-sm-8.px-md-16
  v-container(fluid)
    v-row
      v-col
        v-row(justify="center" align="center")
          v-col.text-md-center(cols="auto")
            h3.mx-2.mb-6.mb-md-12.ibm.text-h4.text-md-h3.primary--text Conheça nossos planos
        v-row(justify="center" align="start")
          v-col
            v-data-table(
              :headers="headers"
              :items="tableAdvantages"
              mobile-breakpoint=0
              hide-default-footer
              disable-sort
              disable-pagination
            )
              template(
                v-for="header in headers"
                #[`header.${header.value}`]="{ header }"
              )
                h4.mb-6.ibm.text-h6.text-sm-h5.text-md-h4.primary--text(
                  v-if="header.value === 'advantage'"
                ) {{ header.text }}
                h4.mb-6.ibm.text-h6.text-sm-h5.text-md-h4.grey--text.text--darken-4(
                  v-else
                ) {{ header.text }}
              template(#item.advantage="{ item }")
                span.heebo.text-body-2.text-md-h6.font-weight-regular.grey--text.text--darken-4 {{ item.title }}
              template(#item.basic="{ item }")
                .my-md-4.d-flex.flex-column.align-center
                  v-img(
                    :src="require(item.basic ? '../../assets/success.svg' : '../../assets/close.svg')"
                    contain
                    eager
                    :width="item.basic ? 36 : 32"
                  )
              template(#item.business="{ item }")
                .my-md-4.d-flex.flex-column.align-center
                  v-img(
                    :src="require(item.business ? '../../assets/success.svg' : '../../assets/close.svg')"
                    contain
                    eager
                    :width="item.business ? 36 : 32"
                  )
              template(#item.pro="{ item }")
                .my-md-4.d-flex.flex-column.align-center
                  v-img(
                    :src="require(item.pro ? '../../assets/success.svg' : '../../assets/close.svg')"
                    contain
                    eager
                    :width="item.pro ? 36 : 32"
                  )
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      headers: [
        {
          value: 'advantage',
          text: 'Vantagens',
          align: 'start'
        },
        {
          value: 'basic',
          text: 'Basic',
          align: 'center'
        },
        {
          value: 'business',
          text: 'Business',
          align: 'center'
        },
        {
          value: 'pro',
          text: 'Professional',
          align: 'center'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('page', ['tableAdvantages'])
  }
}
</script>

<style lang="sass" scoped></style>
